var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTradeEventArrowLeftDown(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 50,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.3 15.2) rotate(207 33.3 11.7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 0 L 66.6 0 L 66.6 23.4 L 0 23.4 Z",
    fill: "transparent"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 65.6 5.7 C 65.6 5.7 30.6 -10.3 6.6 16.7",
    fill: "transparent",
    strokeWidth: 2,
    stroke: "#CEA7FA",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "5.861,3.861"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.3 14.2) rotate(210 33.3 11.7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 0 L 66.6 0 L 66.6 23.4 L 0 23.4 Z",
    fill: "transparent"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 7.9 22.4 L 1.1 21.4 L 2 14.6",
    fill: "transparent",
    strokeWidth: 2,
    stroke: "#cea7fa",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeDasharray: ""
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTradeEventArrowLeftDown);
export default __webpack_public_path__ + "static/media/trade_event_arrow_left_down.3ceded00db4bd16ffa2b46862f94105a.svg";
export { ForwardRef as ReactComponent };